module.exports = __webpack_public_path__ + "img/2-low.a3cf0fdb.jpg";